import type { StatusChipProps } from '@components/v2/ui/StatusChip/StatusChip';
import {
  AbandonedDot,
  ApprovedDot,
  CanceledDot,
  DraftDot,
  InReviewDot,
} from '@components/v2/ui/StatusChip/components/statusIcon.icons';
import LangEnum from '../../../lang/LangEnum';
import { CustomerStatusType } from '../types/customerStatusType';

export const CUSTOMER_STATUS_CHIP_CONFIG: Record<
  CustomerStatusType,
  Omit<StatusChipProps, 'size'>
> = {
  [CustomerStatusType.DRAFT]: {
    label: LangEnum.CUSTOMER_STATUS_DRAFT,
    icon: DraftDot,
    color: 'neutral',
  },
  [CustomerStatusType.PENDING]: {
    label: LangEnum.CUSTOMER_STATUS_PENDING,
    icon: InReviewDot,
    color: 'waiting',
  },
  [CustomerStatusType.APPROVED]: {
    label: LangEnum.CUSTOMER_STATUS_APPROVED,
    icon: ApprovedDot,
    color: 'success',
  },
  [CustomerStatusType.BLOCKED]: {
    label: LangEnum.CUSTOMER_STATUS_BLOCKED,
    icon: CanceledDot,
    color: 'error',
  },
  [CustomerStatusType.INACTIVE]: {
    label: LangEnum.CUSTOMER_STATUS_INACTIVE,
    icon: AbandonedDot,
    color: 'inactive',
  },
};
